export default __webpack_public_path__ + "static/media/Ballroll_00174.dcde7457.png";